import { confidenceLabel, confidenceTone } from '../domain/confidence';

export function ConfidenceBadge({ confidence }: { confidence: number }) {
  return <span className={`badge ${confidenceTone(confidence)}`}>確度 {confidenceLabel(confidence)}</span>;
}
